module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "reg-form"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.labelLetsGetStarted'),
      "titleClass": "regTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.$route.query.hcp) ? _c('p', [_vm._v("Enter the basics to begin personalising your Low Carb Program experience. If\n      you already have an account, "), (_vm.model.offerCode) ? _c('span', [_c('router-link', {
    attrs: {
      "to": ("/login?oc=" + (_vm.model.offerCode))
    }
  }, [_vm._v("click here to log in")])], 1) : _c('span', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("click here to log in")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttonWrap"
  }, [_c('mu-flexbox', {
    attrs: {
      "orient": "vertical"
    }
  }, _vm._l((_vm.providers), function(provider, index) {
    return _c('mu-flexbox-item', {
      key: ("provider-" + index)
    }, [_c('mu-raised-button', {
      staticClass: "loginButton",
      class: {
        darkTextButton: provider.brandColour === '#ffffff',
        buttonImageOnly: !provider.buttonText || !provider.buttonText.length
      },
      style: ({
        backgroundColor: provider.brandColour,
        backgroundImage: provider.buttonText ? '' : ("url(" + (provider.image) + ")")
      }),
      attrs: {
        "type": "button",
        "full-width": "",
        "label": provider.buttonText && provider.buttonText.length ? provider.title.toString().replace(/^/, 'Register using ') : '',
        "disabled": _vm.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.connectAccount(provider.connectUrl)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": provider.image
      }
    })])], 1)
  }), 1)], 1), _vm._v(" "), (_vm.$route.query.hcp) ? _c('p', [_vm._v("Join the free Healthcare Professional Platform")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "align": "baseline"
    }
  }, [_c('mu-flexbox-item', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "id": "firstnameTxt",
      "data-vv-name": "first_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesFirstName'),
      "errorText": _vm.errors.first('first_name'),
      "label": _vm.$t('message.labelYourName'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesFirstName'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.firstname),
      callback: function($$v) {
        _vm.$set(_vm.model, "firstname", $$v)
      },
      expression: "model.firstname"
    }
  })], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "id": "surnameTxt",
      "label": "",
      "data-vv-name": "last_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesSurname'),
      "errorText": _vm.errors.first('last_name'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesSurname'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.surname),
      callback: function($$v) {
        _vm.$set(_vm.model, "surname", $$v)
      },
      expression: "model.surname"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "id": "emailTxt",
      "data-vv-name": "email",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesEmail'),
      "errorText": _vm.errors.first('email'),
      "label": _vm.$t('message.accountPreferencesEmail'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.$set(_vm.model, "email", $$v)
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "id": "emailTxtV",
      "data-vv-name": "emailVerify",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesEmailVerify'),
      "errorText": _vm.errors.first('emailVerify'),
      "label": _vm.$t('message.accountPreferencesEmailVerify'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.emailVerify),
      callback: function($$v) {
        _vm.$set(_vm.model, "emailVerify", $$v)
      },
      expression: "model.emailVerify"
    }
  }), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    ref: "password",
    staticClass: "pw-field",
    attrs: {
      "id": "passwordTxt",
      "type": _vm.model.visible === true ? 'text' : 'password',
      "data-vv-rules": 'required',
      "data-vv-name": "password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesPassword'),
      "label": _vm.$t('message.accountPreferencesPassword'),
      "hintText": _vm.$t('message.accountPreferencesPassword'),
      "errorText": _vm.errors.first('password'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.$set(_vm.model, "password", $$v)
      },
      expression: "model.password"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticClass: "right-icon",
    attrs: {
      "icon": !_vm.model.visible ? 'visibility' : 'visibility_off'
    },
    nativeOn: {
      "click": function($event) {
        _vm.model.visible = !_vm.model.visible
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('password-limit-validation', {
    attrs: {
      "password": _vm.model.password
    }
  }), _vm._v(" "), _c('password-strength-validation', {
    attrs: {
      "password": _vm.model.password
    }
  }), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "passwordTxtV",
      "type": _vm.model.verifyVisible === true ? 'text' : 'password',
      "data-vv-rules": 'required|confirmed:password',
      "data-vv-name": "passwordVerify",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesPasswordVerify'),
      "label": _vm.$t('message.accountPreferencesPasswordVerify'),
      "hintText": _vm.$t('message.accountPreferencesPasswordVerify'),
      "errorText": _vm.confirmPassErr,
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.passwordVerify),
      callback: function($$v) {
        _vm.$set(_vm.model, "passwordVerify", $$v)
      },
      expression: "model.passwordVerify"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticClass: "right-icon",
    attrs: {
      "icon": !_vm.model.verifyVisible ? 'visibility' : 'visibility_off'
    },
    nativeOn: {
      "click": function($event) {
        _vm.model.verifyVisible = !_vm.model.verifyVisible
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n        Date of birth\n      ")]), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.day),
      expression: "dob.day"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_day')
    },
    attrs: {
      "name": "birth_day",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_day",
      "data-vv-as": "day"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Day")]), _vm._v(" "), _vm._l((_vm.dobItems.days), function(day, index) {
    return _c('option', {
      key: 'day-' + index,
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.month),
      expression: "dob.month"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_month')
    },
    attrs: {
      "name": "birth_month",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_month",
      "data-vv-as": "month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._m(0)], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.year),
      expression: "dob.year"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_year')
    },
    attrs: {
      "name": "birth_year",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_year",
      "data-vv-as": "year"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._m(1)], 2)])], 1), _vm._v(" "), _c('p', {
    staticClass: "privacyDisclaimer",
    on: {
      "click": _vm.setTerms
    }
  }, [_c('mu-checkbox', {
    model: {
      value: (_vm.model.terms),
      callback: function($$v) {
        _vm.$set(_vm.model, "terms", $$v)
      },
      expression: "model.terms"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.registerTermsByContinuing')) + "\n        "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "terms"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerTermsAndCondtions')))])], 1), _vm._v(" "), _c('p', {
    staticClass: "privacyDisclaimer",
    on: {
      "click": _vm.setPrivacyPolicy
    }
  }, [_c('mu-checkbox', {
    model: {
      value: (_vm.model.privacyPolicy),
      callback: function($$v) {
        _vm.$set(_vm.model, "privacyPolicy", $$v)
      },
      expression: "model.privacyPolicy"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.registerTermsByContinuing')) + "\n\n        "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "privacy"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerPrivacyPolicy')))]), _vm._v("\n        including\n        "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "cookies"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerIncludingCookie')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('VueRecaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.captchaSiteKey,
      "loadRecaptchaScript": false
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "type": "button",
      "label": _vm.isSaving ? _vm.$t('message.labelProcessing') : _vm.$t('message.registerAppBarText'),
      "disabled": _vm.isSaving,
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1), _vm._v(" "), (_vm.isServerValidationError) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.serverValidationErrorText) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.registerErrorUserExists')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isTermsError) ? _c('alert', {
    staticStyle: {
      "margin-top": "24px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          Please agree to our terms and conditions\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isPrivacyPolicyError) ? _c('alert', {
    staticStyle: {
      "margin-top": "24px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          Please agree to our privacy policy\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isServerValidationError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          " + _vm._s(_vm.serverValidationErrorText) + "\n        ")])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.months), function(month, index) {
    return _c('option', {
      key: 'month-' + index,
      domProps: {
        "value": month
      }
    }, [_vm._v(_vm._s(_vm.localizeMonth(month.name)) + "\n            ")])
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.years), function(year, index) {
    return _c('option', {
      key: 'year-' + index,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year.value) + "\n            ")])
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-874f232e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registration/InitialRegistration.vue
// module id = 3810
// module chunks = 1